export const customizations = (mode, breakpoints) => ({
  palette: {
    mode: mode,
  },
  // Typography themeing
  typography: {
    title: {
      fontFamily: 'Neue Montreal Book',
      fontWeight: 'bold',
      textTransform: 'uppercase',
      fontSize: '3rem',
      [breakpoints.between('xs', 'sm')]: {
        fontSize: '3.5rem',
      },
      [breakpoints.between('sm', 'md')]: {
        fontSize: '4rem',
      },
      [breakpoints.between('md', 'lg')]: {
        fontSize: '4.5rem',
      },
      [breakpoints.up('lg')]: {
        fontSize: '5rem',
      },
    },
    heading: {
      fontFamily: 'Neue Montreal Book',
      fontWeight: '800',
      textTransform: 'uppercase',
      textAlign: 'justify',
      textJustify: 'auto',
      fontSize: '1.8rem',
      [breakpoints.between('xs', 'sm')]: {
        fontSize: '2rem',
      },
      [breakpoints.between('sm', 'md')]: {
        fontSize: '2.2rem',
      },
      [breakpoints.between('md', 'lg')]: {
        fontSize: '2.5rem',
      },
      [breakpoints.up('lg')]: {
        fontSize: '3rem',
      },
    },
    paragraph: {
      fontFamily: 'Neue Montreal Thin',
      fontWeight: '600',
      textAlign: 'justify',
      textJustify: 'auto',
      fontSize: '1rem',
      [breakpoints.between('xs', 'sm')]: {
        fontSize: '1.3rem',
      },
      [breakpoints.between('sm', 'md')]: {
        fontSize: '1.5rem',
      },
      [breakpoints.between('md', 'lg')]: {
        fontSize: '1.7rem',
      },
      [breakpoints.up('lg')]: {
        fontSize: '1.9rem',
      },
    },
    indexNumber: {
      fontFamily: 'Neue Montreal Book',
      fontWeight: '600',
      fontSize: '1rem',
      [breakpoints.between('xs', 'sm')]: {
        fontSize: '1rem',
      },
      [breakpoints.between('sm', 'md')]: {
        fontSize: '1.5rem',
      },
      [breakpoints.between('md', 'lg')]: {
        fontSize: '2rem',
      },
      [breakpoints.up('lg')]: {
        fontSize: '2.5rem',
      },
    },
    summary: {
      fontFamily: 'Neue Montreal Book',
      fontWeight: '600',
      // textTransform: 'uppercase',
      textAlign: '',
      textJustify: 'auto',
      fontSize: '1.3rem',
    },
    outro: {
      fontFamily: 'Neue Montreal Book',
      fontWeight: '600',
      textTransform: 'uppercase',
      textAlign: 'justify',
      textJustify: 'auto',
      fontSize: '1.25rem',
      [breakpoints.between('xs', 'sm')]: {
        fontSize: '1.5rem',
      },
      [breakpoints.between('sm', 'md')]: {
        fontSize: '1.7rem',
      },
      [breakpoints.between('md', 'lg')]: {
        fontSize: '1.9rem',
      },
      [breakpoints.up('lg')]: {
        fontSize: '2.1rem',
      },
    },
  },
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
  },
});
